module.exports = __webpack_public_path__ + "static/media/Kartikeya-Singh.ace2567b.png";